import { render, staticRenderFns } from "./bindtable.vue?vue&type=template&id=cfb29e72"
import script from "./bindtable.vue?vue&type=script&lang=js"
export * from "./bindtable.vue?vue&type=script&lang=js"
import style0 from "./bindtable.vue?vue&type=style&index=0&id=cfb29e72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports